import darkTheme from './dark';
import lightTheme from './light';
import { Theme } from '../types';

const themes = {
	[Theme.DARK]: darkTheme,
	[Theme.LIGHT]: lightTheme,
};
export default themes;
